import React from 'react';
import { Button } from '@ui';
import { translate } from '@utils/i18n';
import { ModeIA } from '@features/IIMReview/types';
import { KendoIntlProvider } from '@contexts/kendo-intl-context';
import ExportButton from '../../nested/ExportButton';
const namespace = 'features.ai_to_review_inspections.bulk_actions';
function BulkActions({ selectedInspections, selectAll, totalCount, modeIa, queryParams, onSelectAll, onBulkCompleteClick, onExportSuccess }) {
    // Hide bulk actions in Teaser mode (read-only)
    if (modeIa === ModeIA.Teaser) {
        return null;
    }
    const disabled = selectedInspections.length === 0;
    const inspectionsCount = selectAll ? totalCount : selectedInspections.length;
    const inspectionIds = !selectAll ? selectedInspections.map((inspection) => inspection.id).join(',') : undefined;
    return (React.createElement("div", { className: "qmb-actions" },
        !disabled && (React.createElement("div", { className: "actions__group--selection" },
            React.createElement("button", { type: "button", className: "actions__selection" },
                React.createElement("span", { className: "actions__count" }, inspectionsCount)),
            !selectAll && (React.createElement("div", { className: "actions__entire" },
                React.createElement("button", { type: "button", tabIndex: 0, className: "qmb-control--sm", onClick: onSelectAll }, translate('select_all_count', { namespace, count: totalCount })))))),
        React.createElement("div", { className: "actions__group" },
            React.createElement(KendoIntlProvider, null,
                React.createElement(Button, { tabIndex: 0, onClick: onBulkCompleteClick, disabled: disabled },
                    React.createElement("i", { className: "fa-light fa-check me-1" }),
                    translate('mark_as_complete', { namespace }),
                    !disabled && ` (${inspectionsCount})`)),
            React.createElement(ExportButton, { disabled: disabled, queryParams: queryParams, inspectionIds: inspectionIds, onExportSuccess: onExportSuccess }))));
}
export default BulkActions;
